import React from "react";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import LoadingSpinner from "../../../Loading/component";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from "@mui/material";
import "./PartnerPayoutList.css";

const PayoutPartnerComponent = ({
  loading,
  error,
  pendingPayouts,
  scheduledPayouts,
  onProceed,
  onMarkSettle,
  onViewSettled,
  onViewPartners,
  onGoBack,
  showMarkSettleDialog,
  setShowMarkSettleDialog,
  selectedDate,
  setSelectedDate,
  onMarkSettledConfirm,
  handleMarkSettleData
}) => {
  const today = new Date();

  return (
    <div className="payout-partner-container">
      {loading ? (
        <LoadingSpinner />
      ) : (
        <>
          <Sidebar />
          <div className="payout-partner-content-wrapper">
            {/* Header Section */}
            <div className="payout-partner-header">
              <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                <button
                  className="payout-partner-back-button"
                  onClick={onGoBack}
                  aria-label="Go back"
                >
                  ←
                </button>
                <h1 className="payout-partner-title">Partner Payout</h1>
              </div>

              <div className="payout-partner-header-actions">
                <button
                  className="payout-partner-action-button payout-partner-view-settled"
                  onClick={() => onViewSettled()}
                >
                  View Settled
                </button>
                <button
                  className="payout-partner-action-button payout-partner-view-partners"
                  onClick={onViewPartners}
                >
                  View Partners
                </button>
              </div>
            </div>

            {/* Pending Payouts Section */}
            <div className="payout-partner-section">
              <h2 className="payout-partner-section-title">Pending Payouts</h2>
              {pendingPayouts.length > 0 ? (
                <div className="payout-partner-table-container">
                  <table className="payout-partner-table">
                    <thead>
                      <tr>
                        <th className="table-header">Date</th>
                        <th className="table-header">Total Generated payout for partner</th>
                        <th className="table-header">Action</th>
                      </tr>
                    </thead>
                    <tbody className="pending-payouts-body">
                      {pendingPayouts.map((payout) => (
                        <tr key={`pending-${payout.id}`}>
                          <td className="table-cell">{payout.date || 'N/A'}</td>
                          <td className="table-cell">{payout.totalGeneratedPayout}</td>
                          <td className="table-cell">
                            <button
                              className="payout-partner-proceed-button"
                              onClick={() => onProceed(payout.date)}
                            >
                              Proceed
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="payout-partner-no-data">No pending payouts available</div>
              )}
            </div>

            <div className="payout-partner-divider"></div>

            {/* Scheduled Payouts Section */}
            <div className="payout-partner-section">
              <h2 className="payout-partner-section-title">Scheduled Payout</h2>
              {scheduledPayouts.length > 0 ? (
                <div className="payout-partner-table-container">
                  <table className="payout-partner-table">
                    <thead>
                      <tr>
                        <th className="table-header">Date</th>
                        <th className="table-header">Total Generated payout for partner</th>
                        <th className="table-header">Action</th>
                      </tr>
                    </thead>
                    <tbody className="scheduled-payouts-body">
                      {scheduledPayouts.map((payout) => (
                        <tr key={`scheduled-${payout.id}`}>
                          <td className="table-cell">{payout.date || 'N/A'}</td>
                          <td className="table-cell">{payout.totalGeneratedPayout}</td>
                          {/* <td className="table-cell">
                            <button
                              className="payout-partner-mark-settle-button"
                              onClick={() => onMarkSettle(payout.date)}
                            >
                              Mark Settle
                            </button>
                          </td> */}
                            <td className="table-cell">
                            <button
                             className="payout-partner-mark-settle-button"
                              onClick={() => handleMarkSettleData(payout.date)}
                            >
                              Mark settle
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="payout-partner-no-data">No scheduled payouts available</div>
              )}
            </div>
          </div>
          <Dialog
            open={showMarkSettleDialog}
            onClose={() => setShowMarkSettleDialog(false)}
            maxWidth="xs"
            fullWidth
            PaperProps={{
              style: {
                borderRadius: '12px',
                padding: '20px',
                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
              },
            }}
          >
            <DialogTitle
              style={{
                fontSize: '20px',
                fontWeight: '600',
                color: '#333',
                textAlign: 'center',
              }}
            >
              Mark Settle
            </DialogTitle>
            <DialogContent style={{ padding: '24px' }}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  value={selectedDate}
                  onChange={(newValue) => setSelectedDate(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      placeholder="Select Date To Mark This Payout As Settled"
                      InputProps={{
                        ...params.InputProps,
                        style: {
                          padding: '12px 16px',
                          border: '1px solid #ccc',
                          borderRadius: '8px',
                          fontSize: '14px',
                          textAlign: 'center',
                        },
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </DialogContent>
            <DialogActions
              style={{
                justifyContent: 'center',
                padding: '16px 24px',
              }}
            >
              <Button
                onClick={onMarkSettledConfirm}
                variant="contained"
                style={{
                  backgroundColor: '#4CAF50',
                  color: 'white',
                  borderRadius: '8px',
                  padding: '10px 24px',
                  textTransform: 'none',
                  fontSize: '14px',
                  fontWeight: '500',
                  boxShadow: 'none',
                  width: '100%',
                  maxWidth: '200px',
                }}
              >
                Done
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )}
    </div>
  );
};

export default PayoutPartnerComponent;